interface Key {
  label: string
  insert?: string
  cursorBack?: number
  action?: 'backspace' | 'clear'
  kind?: 'fn' | 'op' | 'num' | 'ctl'
}

const LAYOUT: Key[][] = [
  [
    { label: '7', insert: '7', kind: 'num' },
    { label: '8', insert: '8', kind: 'num' },
    { label: '9', insert: '9', kind: 'num' },
    { label: '(', insert: '(', kind: 'op' },
    { label: ')', insert: ')', kind: 'op' },
    { label: '^', insert: '^', kind: 'op' },
  ],
  [
    { label: '4', insert: '4', kind: 'num' },
    { label: '5', insert: '5', kind: 'num' },
    { label: '6', insert: '6', kind: 'num' },
    { label: '+', insert: '+', kind: 'op' },
    { label: '−', insert: '-', kind: 'op' },
    { label: '×', insert: '*', kind: 'op' },
  ],
  [
    { label: '1', insert: '1', kind: 'num' },
    { label: '2', insert: '2', kind: 'num' },
    { label: '3', insert: '3', kind: 'num' },
    { label: '÷', insert: '/', kind: 'op' },
    { label: 'x', insert: 'x', kind: 'num' },
    { label: 'π', insert: 'pi', kind: 'num' },
  ],
  [
    { label: '0', insert: '0', kind: 'num' },
    { label: '.', insert: '.', kind: 'num' },
    { label: 'e', insert: 'e', kind: 'num' },
    { label: '√', insert: 'sqrt()', cursorBack: 1, kind: 'fn' },
    { label: 'abs', insert: 'abs()', cursorBack: 1, kind: 'fn' },
    { label: 'ln', insert: 'ln()', cursorBack: 1, kind: 'fn' },
  ],
  [
    { label: 'sin', insert: 'sin()', cursorBack: 1, kind: 'fn' },
    { label: 'cos', insert: 'cos()', cursorBack: 1, kind: 'fn' },
    { label: 'tan', insert: 'tan()', cursorBack: 1, kind: 'fn' },
    { label: 'exp', insert: 'exp()', cursorBack: 1, kind: 'fn' },
    { label: 'log', insert: 'log()', cursorBack: 1, kind: 'fn' },
    { label: '⌫', action: 'backspace', kind: 'ctl' },
  ],
]

export function mountKeypad(container: HTMLElement, input: HTMLInputElement): void {
  container.replaceChildren()
  for (const row of LAYOUT) {
    const rowEl = document.createElement('div')
    rowEl.className = 'keypad-row'
    for (const key of row) {
      const btn = document.createElement('button')
      btn.type = 'button'
      btn.className = `key key-${key.kind ?? 'num'}`
      btn.textContent = key.label
      btn.tabIndex = -1
      btn.addEventListener('click', () => {
        applyKey(input, key)
        input.focus()
      })
      rowEl.append(btn)
    }
    container.append(rowEl)
  }
}

function applyKey(input: HTMLInputElement, key: Key): void {
  const start = input.selectionStart ?? input.value.length
  const end = input.selectionEnd ?? start

  if (key.action === 'clear') {
    input.value = ''
    return
  }

  if (key.action === 'backspace') {
    if (start !== end) {
      input.value = input.value.slice(0, start) + input.value.slice(end)
      input.setSelectionRange(start, start)
      return
    }
    if (start === 0) return
    input.value = input.value.slice(0, start - 1) + input.value.slice(start)
    input.setSelectionRange(start - 1, start - 1)
    return
  }

  const text = key.insert ?? ''
  input.value = input.value.slice(0, start) + text + input.value.slice(end)
  const caret = start + text.length - (key.cursorBack ?? 0)
  input.setSelectionRange(caret, caret)
}
